import React from "react"
import { Bitacoras } from "../components/Bitacora/Bitacoras"

export const BitacoraPage = () => {
    return (
        <Bitacoras />
    )
}